module.exports = __webpack_public_path__ + "static/media/goal-2.73ea81a4.jpg";